import { BlocksRenderer, type BlocksContent } from "@strapi/blocks-react-renderer";
import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

interface ReadMoreBlocksProps {
    content: BlocksContent;
    initialBlockCount?: number;
    labels?: {
        close: string;
        readMore: string;
    };
}

const ReadMoreBlocks: React.FC<ReadMoreBlocksProps> = ({ content, initialBlockCount = 3, labels = { close: "Sulje", readMore: "Lue lisää" } }) => {
    const [expanded, setExpanded] = useState(false);

    const remainingContent = expanded ? content.slice(2) : content.slice(2, initialBlockCount);

    return (
        <div>
            {/* Render first two blocks */}
            {content.length > 0 && <BlocksRenderer content={content.slice(0, 2)} />}

            {/* Button after the first two blocks */}
            {content.length > 2 && (
                <button onClick={() => setExpanded(!expanded)} className="button-style">
                    {expanded ? (
                        <span>
                            {labels.close} <IoIosArrowUp size={20} />
                        </span>
                    ) : (
                        <span>
                            {labels.readMore} <IoIosArrowDown size={20} />
                        </span>
                    )}
                </button>
            )}

            {/* Render remaining blocks conditionally */}
            {remainingContent.length > 0 && <BlocksRenderer content={remainingContent} />}
        </div>
    );
};

export default ReadMoreBlocks;
